import { envSchema, type Env } from './schema';

export type ClientEnv = Env;

function parseClientEnv(): ClientEnv {
    const raw = {
        VITE_API_URL: import.meta.env.VITE_API_URL,
        VITE_SUPPORTED_LOCALES: import.meta.env.VITE_SUPPORTED_LOCALES,
        VITE_DEFAULT_LOCALE: import.meta.env.VITE_DEFAULT_LOCALE,
        VITE_ENABLE_ANALYTICS: import.meta.env.VITE_ENABLE_ANALYTICS,
    };

    const result = envSchema.safeParse(raw);

    if (!result.success) {
        const formatted = result.error.issues
            .map((issue) => `  ✗ ${issue.path.join(".")}: ${issue.message}`)
            .join("\n");

        throw new Error(
            `\n❌ Invalid environment variables:\n${formatted}\n\n` +
            "💡 Copy .env.example to .env and fill in the required values.\n"
        );
    }

    return result.data;
}

/**
 * Validated, type-safe environment variables.
 *
 * @example
 * ```ts
 * import { env } from "@/lib/env/client";
 * const apiUrl = env.VITE_API_URL; // string, guaranteed valid URL
 * ```
 */
export const env = parseClientEnv();
